module.exports = __webpack_public_path__ + "static/media/new_watch_card.5cc1881f.svg";